import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthService } from './auth.service';

const AUTH_REQUIRED_PREFIXES = [
  '/bff/api/users/',
  '/bff/api/library/',
  '/bff/api/movies/admin',
  '/bff/api/series/admin',
  '/bff/api/news/admin',
  '/bff/admin/jobs',
  '/bff/admin/media-catalog/',
  '/bff/admin/subtitles/'
];

const AUTH_OPTIONAL_PREFIXES = ['/bff/api/users/presence/'];

function requiresAuth(url: string, method: string): boolean {
  if (!url.includes('/bff')) {
    return false;
  }

  if (AUTH_OPTIONAL_PREFIXES.some((prefix) => url.includes(prefix))) {
    return false;
  }

  if (AUTH_REQUIRED_PREFIXES.some((prefix) => url.includes(prefix))) {
    return true;
  }

  if (
    url.includes('/bff/api/masterdata/collections/stats') ||
    url.includes('/membership') ||
    url.includes('/by-movie/') ||
    url.includes('/by-series/') ||
    url.includes('/assign-')
  ) {
    return true;
  }

  return (
    url.includes('/bff/api/masterdata/') &&
    method !== 'GET' &&
    method !== 'HEAD'
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  if (!req.url.startsWith(environment.apiBaseUrl) || req.headers.has('Authorization')) {
    return next(req);
  }

  if (!requiresAuth(req.url, req.method) || !auth.isAuthenticated()) {
    return next(req);
  }

  return from(auth.getToken()).pipe(
    switchMap((token) =>
      next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))
    )
  );
};
